/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Messages API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Response with the number of unread messages for this user.
 * @export
 * @interface UnreadMessagesResponse
 */
export interface UnreadMessagesResponse {
    /**
     * Number of unread messages
     * @type {number}
     * @memberof UnreadMessagesResponse
     */
    nbrOfMessages: number;
}

export function UnreadMessagesResponseFromJSON(json: any): UnreadMessagesResponse {
    return UnreadMessagesResponseFromJSONTyped(json, false);
}

export function UnreadMessagesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnreadMessagesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nbrOfMessages': json['nbrOfMessages'],
    };
}

export function UnreadMessagesResponseToJSON(value?: UnreadMessagesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nbrOfMessages': value.nbrOfMessages,
    };
}


